/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CommunicationPreferences/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckboxReadOnly from 'DesignSystem/TysiaCheckboxReadOnly/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CommunicationPreferences({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Detail/Content/CommunicationPreferences"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let selectedLeadMetadataPersonPhonedetailsContactconsentsmsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.metadata.person.phoneDetails.contactConsentSms',
})
let selectedLeadMetadataResponsiblePhonedetailsContactconsentsmsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.metadata.responsible.phoneDetails.contactConsentSms',
})
let aggregateData = fromAggregate.any(selectedLeadMetadataPersonPhonedetailsContactconsentsmsValueData, selectedLeadMetadataResponsiblePhonedetailsContactconsentsmsValueData)
let selectedLeadMetadataPersonPhonedetailsAgreeonsmsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.metadata.person.phoneDetails.agreeOnSms',
})
let selectedLeadMetadataResponsiblePhonedetailsAgreeonsmsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.metadata.responsible.phoneDetails.agreeOnSms',
})
let aggregateData1 = fromAggregate.any(selectedLeadMetadataPersonPhonedetailsAgreeonsmsValueData, selectedLeadMetadataResponsiblePhonedetailsAgreeonsmsValueData)
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Communication Opt Ins"
 level="h4"
/>
<div
  data-testid="CommunicationPreferences.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-17snvw': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="CommunicationPreferences.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 marginRight={dtSpaceXs}
 text="Opted into marketing communications"
/>
<TysiaCheckboxReadOnly
  viewPath={`${viewPath}/TysiaCheckboxReadOnly`}
 data="selected.lead.metadata.person.phoneDetails.contactConsentSms"
 data="selected.lead.metadata.responsible.phoneDetails.contactConsentSms"
 aggregate="/Data/aggregate.js any"
 value={aggregateData}
/>
</div>
<div
  data-testid="CommunicationPreferences.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 marginRight={dtSpaceXs}
 text="Opted into reminder communications"
/>
<TysiaCheckboxReadOnly
  viewPath={`${viewPath}/TysiaCheckboxReadOnly`}
 data="selected.lead.metadata.person.phoneDetails.agreeOnSms"
 data="selected.lead.metadata.responsible.phoneDetails.agreeOnSms"
 aggregate="/Data/aggregate.js any"
 value={aggregateData1}
/>
</div>
</div>
{children}
</React.Fragment>)
}